<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-navigator";
  import { translator, loading } from "../../store";
  import {
    getCities,
    getPropertyOwners,
    getProperty,
    createProperty,
    updateProperty
  } from "../../helpers/apiHelpers/index.svelte";

  import {
    Card,
    TextInput,
    Select,
    Button,
    Textarea,
    Autocomplete,
    FileUpload,
  } from "../../components/index.svelte";
  import { toast, RequestError } from "../../helpers/utils.svelte";

  export let propertyID = null;
  export let formType = null;

  let propertyDetails;
  let propertyOwners = [];
  let cities = [];

  function getFormTitle(formType) {
    let formTitle = "";
    switch (true) {
      case formType === "new":
        formTitle = translator("Yeni Ev Bilgileri");
        break;
      case formType === "edit":
        formTitle = translator("Ev Bilgilerini Düzenle");
        break;
    }
    return translator(formTitle);
  }

  async function handleSubmit(e) {
    const propertyFormData = new FormData(e.target);
    // TODO :: Property files
    /* if (propertyFormData.get(["images[]"])?.size === 0) {
      propertyFormData.delete("images[]");
    } */
    try {
      let saveResp;
      if (formType === "new") {
        saveResp = await createProperty(propertyFormData);
      } else {
        saveResp = await updateProperty(propertyID, propertyFormData);
      }
      if (!saveResp.id) {
        throw new RequestError("Bilinmeyen Hata #o4Wi", {
          message: "Bilinmeyen Hata #a8cD",
        });
      }
      toast.success(
        translator("Başarılı"),
        formType === "edit"
          ? translator("Ev bilgileri güncellendi")
          : translator("Yeni ev oluşturuldu")
      );
      navigate(-1);
    } catch (err) {
      toast.error(translator("Hata"), err.getResponseMessage ? translator(err.getResponseMessage()) : translator(err.message));
    }
  }

  onMount(async () => {
    try {
      $loading = true;
      cities = await getCities();
      propertyOwners = await getPropertyOwners(true);
      if (formType === "edit" && propertyID) {
        propertyDetails = await getProperty(propertyID);
      }
      $loading = false;
    } catch(err) {
      toast.error(translator("Hata"), err.getResponseMessage ? translator(err.getResponseMessage()) : translator(err.message));
    }
  });
</script>
<Card headerText={getFormTitle(formType)}>
  <form
    class="basic-form"
    id="property-form"
    on:submit|preventDefault={handleSubmit}
  >
    <div class="row">
      <div class="col-md-12 p-2">
        <TextInput
          fieldName="name"
          label={translator("Ev İsmi")}
          required
          value={propertyDetails?.name}
        />
      </div>
      <div class="col-md-6 p-2">
        <Autocomplete
          required
          fieldName={"user_id"}
          label={translator("Ev Sahibi")}
          labelField={["firstname", "lastname"]}
          valueField="id"
          placeholder={translator("Lütfen Ev Sahibi Seçiniz")}
          options={propertyOwners}
          value={propertyDetails?.user_id}
        />
      </div>
      <div class="col-md-6 p-2">
        <Select
          fieldName="is_active"
          label={translator("Rezervasyon Durumu")}
          value={propertyDetails?.is_active}
          selectOptions={[
            { text: "Aktif", value: '1' },
            { text: "Pasif", value: '0' },
          ]}
          required
        />
      </div>
      <div class="col-md-6 p-2">
        <TextInput
          type="number"
          fieldName="commission_rate"
          label={translator("Komisyon Oranı")}
          step="0.01"
          value={propertyDetails?.commission_rate}
        />
      </div>
      <div class="col-md-6 p-2">
        <Autocomplete
          required
          fieldName={"city_id"}
          label={translator("Şehir")}
          labelField="name"
          valueField="id"
          placeholder={translator("Lütfen Şehir Seçiniz")}
          options={cities}
          value={propertyDetails?.city_id}
        />
      </div>
      <div class="col-md-6 p-2">
        <TextInput
          fieldName="airbnb_id"
          label={translator("Airbnb ID")}
          required
          value={propertyDetails?.airbnb_id}
        />
      </div>
      <div class="col-md-6 p-2">
        <TextInput
          type="number"
          fieldName="cleaning_fee"
          label={translator("Temizlik Kesintisi")}
          required
          step="0.01"
          value={propertyDetails?.cleaning_fee}
        />
      </div>
      <div class="col-md-12 p-2">
        <Select
          fieldName="currency"
          label={translator("Para Birimi")}
          value={propertyDetails?.currency}
          selectOptions={[
            { text: "TRY", value: 'TRY' },
            { text: "USD", value: 'USD' },
            { text: "EUR", value: 'EUR' },
          ]}
          required
        />
      </div>
      <div class="col-md-12 p-2">
        <Textarea
          fieldName="description"
          label={translator("Açıklama")}
          value={propertyDetails?.description}
        />
      </div>
      <div class="col-md-12 p-2">
        <Textarea
          fieldName="address"
          required
          label={translator("Adres")}
          value={propertyDetails?.address}
        />
      </div>
      <div class="col-md-12 p-2">
        <FileUpload
          fieldName="images[]"
          multiple={true}
          label={translator("Evin fotoğrafları")}
          selectedFiles={propertyDetails?.files || []}
        />
      </div>
    </div>
    <hr />
    <div class="gap-2 d-flex justify-content-end align-items-center">
      <Button formName="property-form" colorCls="btn-success">
        {translator("Kaydet")}
      </Button>
      <Button onClick={() => navigate(-1)} colorCls="btn-dark">
        {translator("Vazgeç")}
      </Button>
    </div>
  </form>
</Card>
